import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const arTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'الاسم (أحرف صغيرة، بدون أحرف خاصة)',
    add: 'أضف',
    allowedFileTypes: 'أنواع الملفات المسموح بها',
    allowedFileTypesDescription:
      'تقييد أنواع الملفات المسموح بها (مثل الصورة/*، التطبيق/pdf). اتركه فارغًا للسماح بجميع الأنواع.',
    allowMultipleFiles: 'السماح بملفات متعددة',
    amountInCents: 'المبلغ بالسنت',
    basePrice: 'السعر الأساسي',
    bcc: 'نسخة مخفية الوجهة',
    brand: 'العلامة التجارية',
    cc: 'CC',
    checkboxPlural: 'حقول خانة الاختيار',
    checkboxSingular: 'خانة الاختيار',
    checkedByDefault: 'تم التحقق بشكل افتراضي',
    chooseConfirmationType:
      'اختر ما إذا كنت تريد عرض رسالة على الصفحة أو إعادة التوجيه إلى صفحة مختلفة بعد إرسال النموذج.',
    condition: 'الحالة',
    confirmationMessage: 'رسالة التأكيد',
    confirmationType: 'نوع التأكيد',
    countryPlural: 'حقول البلاد',
    countrySingular: 'البلد',
    creditCard: 'بطاقة الائتمان',
    customURL: 'عنوان URL مخصص',
    datePlural: 'حقول التاريخ',
    dateSingular: 'التاريخ',
    defaultValue: 'القيمة الافتراضية',
    divide: 'قسمة',
    documentToLinkTo: 'الوثيقة المراد الارتباط بها',
    doesNotEqual: 'لا يساوي',
    emailFrom: 'البريد الإلكتروني من',
    emailPlural: 'حقول البريد الإلكتروني',
    emailsDescription:
      'إرسال رسائل بريد إلكتروني مخصصة عند إرسال النموذج. استخدم قوائم مفصولة بفواصل لإرسال نفس البريد الإلكتروني إلى عدة مستلمين. للإشارة إلى قيمة من هذا النموذج، قم بتغليف اسم هذا الحقل بأقواس متعرجة مزدوجة، أي {{firstName}}. يمكنك استخدام حرف البدل {{*}} لإخراج كافة البيانات و{{*:table}} لتنسيقه كجدول HTML في البريد الإلكتروني.',
    emailSingular: 'البريد الإلكتروني',
    emailTo: 'البريد الإلكتروني ل',
    equals: 'يساوي',
    field: 'الميدان',
    fields: 'الحقول',
    fieldWidth: 'عرض الحقل (نسبة مئوية)',
    hasAnyValue: 'لديه أي قيمة',
    internalLink: 'الرابط الداخلي',
    label: 'التسمية',
    maxFileSize: 'الحد الأقصى لحجم الملف (بايت)',
    maxFileSizeDescription: 'الحد الأقصى لحجم الملف بالبايت. اتركها فارغة بلا حدود.',
    message: 'رسالة',
    messageDescription: 'أدخل الرسالة التي ينبغي إرسالها في هذا البريد الإلكتروني.',
    messagePlural: 'كتل الرسائل',
    messageSingular: 'رسالة',
    mimeType: 'نوع MIME',
    mimeTypePlural: 'أنواع MIME',
    mimeTypeSingular: 'نوع MIME',
    multiply: 'اضرب',
    numberPlural: 'حقول الأرقام',
    numberSingular: 'رقم',
    optionPlural: 'خيارات',
    optionSingular: 'الخيار',
    paymentFieldPlural: 'مجالات الدفع',
    paymentFieldSingular: 'الدفع',
    paymentProcessor: 'معالج الدفع',
    paymentStatus: 'الحالة',
    placeholder: 'العنصر النائب',
    priceConditions: 'شروط السعر',
    priceConditionsPlural: 'شروط السعر',
    priceConditionsSingular: 'حالة السعر',
    radioOptions: 'خيارات سمة الراديو',
    radioPlural: 'مجالات الراديو',
    radioSingular: 'راديو',
    redirect: 'إعادة التوجيه',
    replyTo: 'الرد على',
    required: 'مطلوب',
    selectOptions: 'حدد الخيارات',
    selectPlural: 'حدد الحقول',
    selectSingular: 'اختر',
    statePlural: 'مجالات الدولة',
    stateSingular: 'الدولة',
    staticValue: 'القيمة الثابتة',
    subject: 'الموضوع',
    submitButton: 'إرسال تسمية الزر',
    subtract: 'اطرح',
    textareaPlural: 'حقول منطقة النص',
    textareaSingular: 'منطقة النص',
    textPlural: 'حقول النص',
    textSingular: 'نص',
    title: 'العنوان',
    token: 'رمز مميز',
    uploadCollection: 'تحميل المجموعة',
    uploadCollectionDescription: 'حدد مجموعة التحميل التي تريد تخزين الملفات فيها',
    uploadFieldPlural: 'تحميل الحقول',
    uploadFieldSingular: 'تحميل',
    urlToRedirectTo: 'عنوان URL لإعادة التوجيه إليه',
    value: 'القيمة',
    valueOfField: 'قيمة الحقل',
    valueType: 'نوع القيمة',
  },
}

export const ar: PluginLanguage = {
  dateFNSKey: 'ar',
  translations: arTranslations,
}
